// extracted by mini-css-extract-plugin
module.exports = {"field":"Field_field_K7O8A","left":"Field_left_1B1yC","icon":"Field_icon_2xHtL","info":"Field_info_tepIf","right":"Field_right_2roWk"};